import React from 'react'

import EstimateRevisions from './EstimateRevisions'
import LatestRevisions from './LatestRevisions'
import { EarningsRevisionsByType } from './types'

interface Props {
  revisionData: EarningsRevisionsByType | null
}

export default function EarningsRevisions({ revisionData }: Props) {
  if (!revisionData) {
    return null
  }
  return (
    <div className="rounded-md border border-primary pb-3 pl-3 pr-3 pt-3 text-muted">
      <LatestRevisions revisionData={revisionData} />
      <EstimateRevisions revisionData={revisionData} />
    </div>
  )
}
